import React from 'react';

import Icon, {Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';

type Props = {
    text: string,
};

export const McpTooltip = ({text}: Props) => (
    <Tooltip
        color="light"
        placement="right"
        anchor={({getAnchorProps, anchorRef}) => (
            <Icon
                ref={anchorRef}
                type={Icons.INFO}
                {...getAnchorProps()}
            />
        )}>
        <div style={{width: 250}}>
            {text}
        </div>
    </Tooltip>
);
